<header name="auth-menu" attr.data-env="{{env}} | {{build}}">
  <nav class="navbar">
    <ul class="navbar-nav flex-row">
      <!-- authenticated -->
      <ng-container *ngIf="isLoggedIn else notAuthenticated">
        <!-- user menu: desktop -->
        <li dropdown [autoClose]="false" class="nav-item dropdown d-none d-lg-flex">
          <a name="dropdown-toggle" 
            dropdownToggle 
            class="nav-link dropdown-toggle" 
            role="button" 
            [attr.data-user]="userEmail" (click)="toggleAuthMenu()">
            Account
          </a>
          <div *dropdownMenu class="dropdown-menu align-right">
            <a name="profile" class="dropdown-item" [href]="profileLink">Profile</a>
            <a name="bookings" class="dropdown-item" [href]="bookingsLink">Bookings</a>
            <div class="dropdown-divider"></div>
            <a name="log-out" class="dropdown-item tint" (click)="logOut()">Log out</a>
          </div>
        </li>
        <!-- user menu: toggle button mobile -->
        <li dropdown [autoClose]="false" class="nav-item dropdown d-lg-none">
          <button id="user-menu-mobile" dropdownToggle type="button" (click)="toggleAuthMenu()" 
            class="navbar-toggler btn btn-tertiary color-brand-4 navbar-toggler-right" 
            [attr.data-user]="userEmail">
            Account
            <i name="menu-closed-icon" class="ml-1 jr-icon"
              [ngClass]="{'chevron-up': !isAuthMenuCollapsed, 'chevron-down': isAuthMenuCollapsed}"></i>
          </button>
          <ul *dropdownMenu class="dropdown-menu align-stretch">
            <div class="dropdown-divider"></div>
            <li class="nav-item">
              <a name="profile" class="nav-link text-nowrap" (click)="collapseAuthMenu()" [href]="profileLink">
                Profile
              </a>
            </li>
            <li class="nav-item">
              <a name="bookings" class="nav-link text-nowrap" (click)="collapseAuthMenu()" [href]="bookingsLink">
                Bookings
              </a>
            </li>
  
            <div class="dropdown-divider"></div>
  
            <li class="nav-item">
              <a name="log-out" class="nav-link text-nowrap tint" (click)="logOut(); collapseAuthMenu()">
                Log out
              </a>
            </li>
          </ul>
        </li>
      </ng-container>
      <!-- not authenticated -->
      <ng-template #notAuthenticated>
        <li class="nav-item mr-3 mr-lg-0">
          <a class="nav-link text-nowrap color-brand-4" 
            role="button" 
            name="log-in" 
            (click)="collapseJoinMenu(); logIn(false)">
            Sign in
          </a>
        </li>

        <ng-container *ngIf="isAgentMenu else travellerMenu">
          <li class="nav-item">
            <a class="btn btn-primary-alt btn-sm" 
              role="button" 
              name="join" 
              (click)="signUpAsAgent()">
              Join
            </a>
          </li>
        </ng-container>
        <ng-template #travellerMenu>
          <!-- join menu: desktop -->
          <li dropdown [autoClose]="false" class="nav-item dropdown d-none d-lg-flex">
            <a name="join-toggle" 
              dropdownToggle 
              class="nav-link text-nowrap highlight btn-sm" 
              role="button">
              Join
            </a>
            <!-- nav-link  -->
            <div *dropdownMenu class="dropdown-menu align-right">
              <strong>Join as a:</strong>
              <div class="dropdown-divider"></div>
              <a name="traveller" 
                class="dropdown-item" 
                (click)="logIn(true)">
                  <i class="mr-1 jr-icon person"></i>
                  Traveller
              </a>
              <div class="dropdown-divider"></div>
              <a name="agent" 
                class="dropdown-item" 
                [href]="linkTravelAgents">
                  <i class="mr-1 jr-icon earth"></i>
                  Agent
              </a>
              <a name="affiliate" 
                class="dropdown-item" 
                [href]="linkAffiliates">
                  <i class="mr-1 jr-icon share"></i>
                  Affiliate
              </a>
              <a name="transport-company" 
                class="dropdown-item" 
                [href]="linkTransportCompanies">
                  <i class="mr-1 jr-icon car-and-bus"></i>
                  Transport Company
              </a>
            </div>
          </li>

          <!-- join menu: mobile -->
          <li dropdown [autoClose]="false" class="nav-item dropdown d-lg-none">
            <!-- nav-link  -->
            <a class="nav-link text-nowrap highlight btn-sm" 
                [ngClass]="{'show': !isJoinMenuCollapsed}"
                role="button" 
                name="humburger-join-menu" 
                dropdownToggle 
                (click)="toggleJoinMenu()"
              >
                Join
            </a>
            <ul *dropdownMenu class="dropdown-menu align-stretch">
              <!-- <div class="dropdown-divider"></div> -->
              <li class="nav-item">
                <strong>Join as a:</strong>
            </li>
            <div class="dropdown-divider"></div>
            <li class="nav-item">
                <a name="traveller" 
                  class="nav-link text-nowrap" 
                  (click)="logIn(true)">
                    <i class="mr-1 jr-icon person"></i>
                    Traveller
                </a>
              </li>
              <li class="nav-item">
                  <a name="agent" 
                    class="nav-link text-nowrap" 
                    target="_blank" 
                    [href]="linkTravelAgents">
                      <i class="mr-1 jr-icon earth"></i>
                      Agent
                  </a>
              </li>
              <li class="nav-item">
                  <a name="affiliate" 
                    class="nav-link text-nowrap" 
                    target="_blank" 
                    [href]="linkAffiliates">
                      <i class="mr-1 jr-icon share"></i>
                      Affiliate
                  </a>
              </li>
              <li class="nav-item">
                  <a name="transport-company" 
                    class="nav-link text-nowrap" 
                    target="_blank" 
                    [href]="linkTransportCompanies">
                      <i class="mr-1 jr-icon car-and-bus"></i>
                      Transport Company
                  </a>
              </li>
            </ul>
          </li>
        </ng-template>
      </ng-template>
    </ul>
  </nav>
</header>